import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { ProductCategoryProvider } from "../../providers/product-category/product-category";
import { ProductCategory } from "../../models/product-category.model";

import { ProductDetailPage } from "../product-detail/product-detail";
import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-products',
  templateUrl: 'products.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ProductsPage {

  productCategoryID: number;
  productCategoryName: string;

  searchBarEntry: string = '';

  productCategories: ProductCategory[];

  loading: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public productCategoryProvider: ProductCategoryProvider) {
    this.productCategoryID = navParams.get('productCategoryID');
    this.productCategoryName = navParams.get('productCategoryName');
  }

  getProductCategoriesWithProducts(id: number) {
    this.loading = true;
    this.productCategoryProvider.getChildrenByID(id, true)
      .subscribe(
        productCategories => this.productCategories = productCategories,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  reloadProductCategoriesWithProducts(refresher) {
    this.productCategoryProvider.getChildrenByID(this.productCategoryID, true)
      .subscribe(
        productCategories => this.productCategories = productCategories,
        error => {
          refresher.complete();
        },
        () => {
          refresher.complete();
        }
      );
  }

  openDetail(product) {
    this.navCtrl.push(ProductDetailPage, {
      id: product.id
    });
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getProductCategoriesWithProducts(this.productCategoryID);
  }

  //Searchbar
  inField(productCategories){
    if (!this.searchBarEntry) return productCategories;

    return JSON.parse(JSON.stringify(productCategories)).filter((cat) => {
      cat.products = cat.products.filter((product) => {
        return product.name.toLowerCase().includes(this.searchBarEntry.toLowerCase());
      })

      return (cat.products);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/products/products.ts